import React from 'react';

import './membership-payment-message.scss';
import HalalboxPrimeIcon from 'assets/halalbox-prime/hb-prime-banner-icon.png';

const MembershipPaymentMessage = ({ membershipDetails }) => {
  const { membershipTitle = '', membershipDescription = '' } =
    membershipDetails || {};
  return (
    <div className="membership-message">
      <div className="membership-message-img-container">
        <img src={HalalboxPrimeIcon} className="membership-message-img" />
      </div>
      <div className="membership-message-info-container">
        <span>{membershipTitle}</span>
        <span>{membershipDescription}</span>
      </div>
    </div>
  );
};

export default MembershipPaymentMessage;
